// extracted by mini-css-extract-plugin
module.exports = {"root":"PendingPaymentAlert_root__1-nwA","buttons":"PendingPaymentAlert_buttons__4dc3M"};